import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, AbstractControl, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { AppsettingsConfig } from '../../client-config/models/client-config';
import { Router } from '@angular/router';
import { ConfigService } from '../../client-config/services/config.service';
import { CodeEnum } from 'src/app/core/shared/enums/codeEnum';
import { PasswordRecoveryEnum } from 'src/app/core/shared/enums/password-recovery.enum';
import { strictEmailValidator } from 'src/app/core/models/custom-validators.model';
export interface IPasswordChangePasswordRequest {
  token: string;
  password: string;
}
export interface IPasswordChangePasswordResponse {
  phone: string;
  mode: PasswordRecoveryEnum;
}
export interface IChangePasswordByPassword {
  currentPassword: string;
  password: string;
  verifyPwd: string;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordRecoveryService {
  backendUrl;

  checkPasswords: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('repeat')?.value;
    return pass === confirmPass ? null : { notSame: true };
  };

  //Форма Восстановление пароля.
  //Проверок существования почты и статуса УЗ здесь нет: по ответу нельзя определять, зарегистрирован ли адрес
  strangerform = this.fb.group({
    email: [
      '',
      {
        validators: [Validators.required, strictEmailValidator],
        updateOn: 'blur',
      },
    ],
  });

  /** форма для страницы "Новый пароль" */
  confirmationForm = this.fb.group(
    {
      password: [
        '',
        {
          validators: [Validators.required, Validators.minLength(8), Validators.maxLength(32), this.createPasswordStrengthValidator()],
        },
      ],
      repeat: [''],
    },
    { validators: this.checkPasswords }
  );

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    appsettings: AppsettingsConfig,
    configService: ConfigService,
    private router: Router
  ) {
    const confirmPasswordPage = configService.customization.getOptionBool(CodeEnum.CONFIRM_PWD);
    if (!confirmPasswordPage) {
      this.router.navigate(['/auth/signin']);
    }

    this.backendUrl = appsettings.backendUrl;
  }

  createPasswordStrengthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return null;
      }

      const hasUpperCase = /[A-Z]+/.test(value);

      const hasLowerCase = /[a-z]+/.test(value);

      const hasNumeric = /[0-9]+/.test(value);

      const passwordValid = hasUpperCase && hasLowerCase && hasNumeric;

      return !passwordValid ? { passwordStrength: true } : null;
    };
  }
  //Восстановление пароля, проверяем капчу и существования почты, создаем новую запись в ChangePasswords и отправляем письмо пользователю
  passwordChangeInit(model: FormData): Observable<any> {
    return this.http.post(`${this.backendUrl}/account/PasswordChangeInit`, model);
  }
  /**
   * Проставляем новый пароль в таблицу Восстановления пароля
   */
  passwordChangePassword(model: IPasswordChangePasswordRequest): Observable<IPasswordChangePasswordResponse> {
    return this.http.post<IPasswordChangePasswordResponse>(`${this.backendUrl}/account/password-change-password`, model);
  }
  /**
   * Замена текущего папроля на новый
   */
  changePasswordByPassword(model: IChangePasswordByPassword): Observable<boolean> {
    return this.http.patch<boolean>(`${this.backendUrl}/account/change-password-by-password`, model);
  }

  checkToken(token: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.backendUrl}/account/CheckToken?` + 'token=' + token, null);
  }
}
